import { RootState } from '@checkout/state';
import { Epic, ofType } from 'redux-observable';
import { map } from 'rxjs/operators';
import { ChangeStepSuccessAction, RootAction } from '../actions/actionTypes.d';
import ActionTypes from './../actions/actionTypes';
import { changeStepSuccess } from './../reducers/checkout';

export const changeStepEpic: Epic<RootAction, RootAction, RootState> =
  (action$, state$) => action$.pipe(
    ofType(ActionTypes.CHANGE_STEP_REQUEST),
    map((action: ChangeStepSuccessAction) => changeStepSuccess({ step: action.payload.step }))
  );
